import styled, { css } from 'styled-components';

import { ReactComponent as IncreaseArrow } from '@pkg/components/Sections/Profile/icons/increase-arrow.svg';

interface ArrowProps {
    $isDecrease?: boolean;
    $size?: number;
}

export const Wrapper = styled.div<ArrowProps>`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    line-height: 90%;
    color: #6dff7c;
    display: flex;
    letter-spacing: 0.1px;
    align-items: flex-end;

    ${({ $size }) => css`
        font-size: ${$size || '12'}px;
    `}

    ${({ $isDecrease }) =>
        $isDecrease &&
        css`
            color: #ff004c;
        `}


    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        padding-top: 2px;
        padding-bottom: 0;
        ${({ $size }) =>
            $size &&
            css`
                padding: 0;
            `}
    }
`;

export const Arrow = styled(IncreaseArrow)<ArrowProps>`
    width: 10px;
    margin-right: 1px;
    stroke: #6dff7c;

    position: relative;
    top: 1px;

    ${({ $isDecrease }) =>
        $isDecrease &&
        css`
            transform: rotate(180deg);
            stroke: #ff004c;
            top: 2px;
        `}
`;
